import React, { useEffect, useState } from "react";
import { Grid, Header, Divider, Table, label, Button } from "semantic-ui-react";
import { reduxForm, Field, FieldArray } from "redux-form";
import {
  renderTextField,
  renderOptionField,
  amountsAre,
  spentAs,
  renderTextAreaField,
} from "../formcomponents";
import RecivedMoneyFieldArr from "./RecivedMoneyFieldArr";
import SpendMoneyFieldArr from "./SpendMoneyFieldArr";
import axios from "axios";
import { BaseUrlInvoice, ImageUrl } from "../formcomponents/Constants";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router";
import { userData } from "../store/userData";
import ImageFileUploadFileId from "../formcomponents/ImageFileUploadFileId";
import FileUpladArr from "./FileUplaad/FileUpladArr";
const SpendMoney = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  const navigate = useNavigate();
  const [userDetail, setuserDetail] = useState("");
  const [totalAmount, settotalAmount] = useState("");
  const { id, catid } = useParams();
  const [buttonDisable, setbuttonDisable] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [downloadImage, setdownloadImage] = useState();
  const [uploadedImageList, setuploadedImageList] = useState([]);
  const formatDateToYYYYMMDD = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  useEffect(() => {
    const userDetail = userData();

    setuserDetail(userDetail);
    if (id !== "null") {
      if (userDetail.userRole != 1) {
        setbuttonDisable(true);
      }
      getSpentMoneyDetails(id);
    } else {
      const today = new Date();
      props.initialize({
        spentDate: formatDateToYYYYMMDD(today),
        itemList: [{}],
        fileList: [{}],
      });
    }
  }, [totalAmount]);

  const getSpentMoneyDetails = (id) => {
    axios
      .post(BaseUrlInvoice + "accounts/getSpendMoney", { spendMoneyId: id })
      .then((res) => {
        console.log("spenrmoney", res.data);
        preInitialForm(res.data);

        if (res.data.fileReference != "null") {
          setdownloadImage(res.data.fileReference);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleClick = (event, url) => {
    // 👇️ refers to the image element
    window.open(url, "_blank", "noopener,noreferrer");
  };
  const preInitialForm = (tempData) => {
    props.initialize({
      spendMoneyId: id,
      spentPaymentAs: tempData.spentPaymentAs,
      spentAs: tempData.spentAs,
      spentTo: tempData.spentTo,
      spentDate: tempData.spentDate,
      remarks: tempData.remarks,
      amountsAre: tempData.amountsAre,
      itemList: tempData.itemList,
      fileReference: tempData.fileReference,
      fileList: [{}],
    });
    setuploadedImageList(tempData.fileList);
    settotalAmount(tempData.totalAmount);
  };

  const sumbitForm = (values) => {
    setIsSubmitting(true);
    const currencyConversion = [
      { option: "AED", value: 1 },
      { option: "EUR", value: 3.93 },
      { option: "USD", value: 3.67 },
      { option: "INR", value: 22.59 },
    ];

    let tempArr = [];
    if (values.itemList != "") {
      values.itemList.forEach((item) => {
        const itemQty = item.itemQty;
        const unitPrice = item.unitPrice;
        const currency = item.currency;
        const filterItem = currencyConversion.find(
          (item) => item.option === currency
        );
        const total = Number(itemQty) * Number(unitPrice);
        const withtax = total + Number(item.taxRate || 0);
        const convertAmount = withtax * filterItem.value;
        console.log("total", convertAmount);

        // Include the itemId from the original item in tempArr
        tempArr.push({
          itemDetailId: item.itemDetailId, // Set itemId
          itemName: item.itemName,
          itemDescription: item.itemDescription,
          itemQty: item.itemQty,
          unitPrice: item.unitPrice,
          currency: item.currency,
          acccount: item.acccount,
          taxRate: item.taxRate,
          region: item.region,

          amount: convertAmount,
        });
      });
    }

    const imageList = [...values.fileList, ...uploadedImageList];
    const submitObject = {
      ...values,
      fileList: imageList,
      itemList: tempArr, // Replace existing itemList with tempArr
      userId: userDetail.userId,
      categoryId: catid,
    };

    console.log("submitObjectsubmitObject", submitObject);
    axios
      .post(BaseUrlInvoice + "accounts/createSpendMoney", submitObject)
      .then((res) => {
        console.log("res.data", res.data);
        if (res.data.errCode === 200) {
          Swal.fire("New Record Added");
          navigate(`/list-spend-money/${res.data.categoryId}`);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          Spend Money
        </Header>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      <Grid.Row>
        <Button type="submit" primary onClick={() => navigate(-1)}>
          Go Back
        </Button>
        <Button
          type="submit"
          floated="right"
          positive
          disabled={buttonDisable || isSubmitting}
          onClick={handleSubmit((values) =>
            sumbitForm({
              ...values,
            })
          )}
        >
          Save
        </Button>
        <Button
          floated="right"
          negative
          disabled={pristine || submitting}
          onClick={reset}
        >
          Cancel
        </Button>{" "}
      </Grid.Row>
      <Grid.Row>
        <Grid columns="seven">
          <Grid.Row>
            <Grid.Column>
              {/* <Field
                name="spentAs"
                label="Spent As"
                options={spentAs}
                component={renderOptionField}
              /> */}
              <Field
                name="spentPaymentAs"
                label="Spent As"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              {" "}
              <Field
                name="spentTo"
                label="To"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              {" "}
              <Field
                name="spentDate"
                label="Date"
                type="date"
                component={renderTextField}
              />{" "}
            </Grid.Column>
            <Grid.Column></Grid.Column>
            <Grid.Column> </Grid.Column>
            <Grid.Column> </Grid.Column>
            <Grid.Column>
              <Field
                name="amountsAre"
                label="Amounts Are"
                options={amountsAre}
                component={renderOptionField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      <FieldArray
        name="itemList"
        totalAmountget={totalAmount}
        component={SpendMoneyFieldArr}
      />
      <FieldArray name="fileList" component={FileUpladArr} />
      {uploadedImageList.length > 0 && (
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>File Name</Table.HeaderCell>
              <Table.HeaderCell>Download Link</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {uploadedImageList.map((item, index) => (
              <Table.Row key={index}>
                <Table.Cell collapsing>{item.fileTypeName}</Table.Cell>
                <Table.Cell collapsing>
                  <p
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      window.open(
                        ImageUrl + item.fileName,
                        "_blank",
                        "noopener,noreferrer"
                      )
                    }
                  >
                    Download
                  </p>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      )}
      {/* <Grid.Row>
        <Grid columns="four">
          <Grid.Row>
            <Grid.Column></Grid.Column>
            <Grid.Column>
              {" "}
              {id != "null" && (
                <>
                  <img
                    src={ImageUrl + downloadImage}
                    height="150px"
                    width="150px"
                  />
                  <Button
                    positive
                    onClick={(event) =>
                      handleClick(event, ImageUrl + downloadImage)
                    }
                  >
                    Download File
                  </Button>
                </>
              )}
            </Grid.Column>
            <Grid.Column></Grid.Column>
            <Grid.Column>
              {" "}
              <div
                style={{
                  marginTop: "25px",
                }}
              >
                <Field
                  name="fileReference"
                  type="file"
                  component={ImageFileUploadFileId}
                  label="File"
                />
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row> */}
      <Field name="remarks" component={renderTextAreaField} label="Remarks" />
      <br />
      <br />
      <></>
    </div>
  );
};

export default reduxForm({
  form: "SpendMoney",
})(SpendMoney);
